import React, {Component} from 'react'
import ReactDOM from 'react-dom'

import styles from './About1.module.scss'
import { Transition } from 'semantic-ui-react';

class About1 extends Component {
    language = this.props.language;

    constructor(props) {
        super(props);
        this.state = {
            isPageVisible: false
        }

        this.getLanguageClass = this.getLanguageClass.bind(this);
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                isPageVisible: true,
            });
        }, 0);
    }

    scrollToProducer = () => {
        window.scroll({'behavior': 'smooth', 'top': 800});
    }

    getLanguageClass = () => {
        switch(this.props.language) {
            case "EN":
                return styles.en;
            default:
                return '';
        }
    }

    render() {
        return (
            <>
                <div className={`${styles.about} ${styles.desktop} ${this.getLanguageClass()}`}>
                    <div className={styles.content}>
                        <div className={styles.content_overlay}></div>
                        <Transition visible={this.state.isPageVisible} animation='fade' duration={1500}>
                        <div className={styles.content_logo}>
                            <img src={process.env.PUBLIC_URL + "/images/menu/ol_Logo_2019ver-w.png"}/>
                        </div>
                        </Transition>
                        <Transition visible={this.state.isPageVisible} animation='fade' duration={1500}>
                        <div className={styles.content_description} onScroll={(e)=>{console.log("scrolling");e.stopPropagation();e.preventDefault();return false;}}>
                            <div className={styles.description_container} dangerouslySetInnerHTML={{__html: this.props.about.aboutDescription}}>
                                {/*<div className="justify">*/}
                                {/*    邊境映象藝文有限公司創立於2015年。電影是一門創作團隊之間靈思相互激盪，以人為核心的藝術；在一部電影的生命週期裡，製片人扮演相當重要的角色。在台灣的影像製作業中，不乏許多優秀的製片人才，並且眾人各有所長。 但若非單一個人，而是一組優秀且各有擅長的製片團隊呢？它所匯積的能量，是否會更具可能性呢？ 而這正是邊境相對於其他製片人間的區隔與特色。*/}
                                {/*</div>*/}
                                {/*<div className="justify">*/}
                                {/*    邊境除了原先主要從事項目影像製作、國內外協拍，亦開始進行影視開發領域的工作。陸續與多位導演合作參與劇本開發、編劇創作等，公司業務核心的焦點，逐步著力於影片製作專案開發、 資金募集、國際市場操作等面向，秉持著創造高品質、兼具文化與市場、台灣魅力與國際視野的電影佳作， 為電影圈與電影觀眾開啟新視野。*/}
                                {/*</div>*/}
                            </div>
                        </div>
                        </Transition>
                    </div>
                </div>
                <div className={`${styles.about} ${styles.mobile} ${this.getLanguageClass()}`}>
                    <div className={styles.content}>
                        <div className={styles.content_logo}>
                            <img src={process.env.PUBLIC_URL + "/images/menu/ol_Logo_2019ver-w.png"}/>
                        </div>
                        <div className={styles.content_description}>
                            <div className={`${styles.description_container} mobile_spacing`}
                                 onScroll={e => e.stopPropagation()} dangerouslySetInnerHTML={{__html: this.props.about.aboutDescription}}>
                                {/*<div className="justify">*/}
                                {/*    邊境映象藝文有限公司創立於2015年。電影是一門創作團隊之間靈思相互激盪，以人為核心的藝術；在一部電影的生命週期裡，製片人扮演相當重要的角色。在台灣的影像製作業中，不乏許多優秀的製片人才，並且眾人各有所長。 但若非單一個人，而是一組優秀且各有擅長的製片團隊呢？它所匯積的能量，是否會更具可能性呢？ 而這正是邊境相對於其他製片人間的區隔與特色。*/}
                                {/*</div>*/}
                                {/*<div className="justify">*/}
                                {/*    邊境除了原先主要從事項目影像製作、國內外協拍，亦開始進行影視開發領域的工作。陸續與多位導演合作參與劇本開發、編劇創作等，公司業務核心的焦點，逐步著力於影片製作專案開發、 資金募集、國際市場操作等面向，秉持著創造高品質、兼具文化與市場、台灣魅力與國際視野的電影佳作， 為電影圈與電影觀眾開啟新視野。*/}
                                {/*</div>*/}
                            </div>
                        </div>
                        {/*<div className={styles.scroll_down}>*/}
                        {/*    <div className={styles.text}>監製 / 製片人介紹</div>*/}
                        {/*    <div className={`${styles.arrow_block} ${styles.arrow_block_down} `}>*/}
                        {/*        <div className={`arrow down ${styles.arrow} ${styles.top}`}></div>*/}
                        {/*        <div className={`arrow down ${styles.arrow} ${styles.down}`}></div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>
            </>
        );
    }

};

export default About1;
